import React, { useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import './transaction-forms.scss';
import { RouteComponentProps } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity } from '../quotation/quotation.reducer';
import moment from 'moment';
import {fontStyle} from "html2canvas/dist/types/css/property-descriptors/font-style";
import {Storage, Translate, translate} from "react-jhipster";
import { getEntitiesByEcertNo as getBursaApiOrderResult } from "app/entities/bursa-api-order-result/bursa-api-order-result.reducer";
import {forceLogoAlignment, resolveAgreementDateAtQuotationTime} from "app/shared/util/quotation-utils";
import {formatCurrency} from 'app/shared/util/currency-utils';
import {getEntitiesByBankId as getBankAgreementDateLogs} from 'app/entities/bank-agreement-date-log/bank-agreement-date-log.reducer';

const logo = '../../../content/images/img.png';
const watermark = '../../../content/images/watermark.png';
const footer = '../../../content/images/footer-transaction-forms.jpg';

export const LocalTransactionFormsTransfer = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const quotationEntity = useAppSelector(state => state.quotation.entity);
  const agreementDateLogs = useAppSelector(state => state.bankAgreementDateLog.entities);

  const captureRef = useRef(null);

  const sleep = milliseconds => {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
  };

  function separator(str, sep) {
    str = str?.substring(0, str.length - 3);
    let output = '';
    for (let i = str?.length; i > 0; i -= 2) {
      const ii = i - 1;
      if (output) {
        output = str?.charAt(ii - 1) + str?.charAt(ii) + sep + output;
      } else {
        output = str.charAt(ii - 1) + str.charAt(ii);
      }
    }
    return output;
  }

  function agreementDateFormat(q) {
    const date = resolveAgreementDateAtQuotationTime(q, agreementDateLogs);
    if (!date) {
      return '-';
    }
    if (Storage.session.get('locale') === 'en') {
      return moment(date).format('DD/MM/yyyy');
    } else {
      return moment(date).format('yyyy/MM/DD');
    }
  }

  const generatePDFArabic = async () => {
    const element = captureRef.current;

    if (!element) {
      console.error('Element ref is null, cannot generate PDF');
      return;
    }

    // Increase the scale factor to improve image resolution
    const scale = 4; // Increase scale factor to improve resolution
    const canvas = await html2canvas(element, { scale });
    const imgData = canvas.toDataURL('image/png');

    // Create a new PDF document
    const pdf = new jsPDF('p', 'pt', 'a4', true);

    // Get dimensions of the PDF page
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    // Calculate dimensions to maintain the aspect ratio
    const imgWidth = canvas.width / scale;
    const imgHeight = canvas.height / scale;
    let width, height;

    if (imgWidth / pdfWidth > imgHeight / pdfHeight) {
      width = pdfWidth;
      height = (imgHeight / imgWidth) * pdfWidth;
    } else {
      height = pdfHeight;
      width = (imgWidth / imgHeight) * pdfHeight;
    }

    // Add the image to the PDF
    pdf.addImage(imgData, 'PNG', 0, 0, width, height);

    // Save the PDF
    if (Storage.session.get('locale') === 'ar-ly') {
      pdf.save(`Transaction_Forms_Transfer_${localStorage.getItem('ecertNo')}_ARB.pdf`);
    } else {
      pdf.save(`Transaction_Forms_Transfer_${localStorage.getItem('ecertNo')}_ENG.pdf`);
    }
  };

  useEffect(() => {
    // dispatch(getQuotationBybursaAPIOtcCertId(props.match.params.id));
    dispatch(getEntity(props.match.params.id));
  }, []);

  useEffect(() => {
    dispatch(getBursaApiOrderResult(quotationEntity?.bursaAPIOtcCert?.ecertNo));
  }, [quotationEntity]);

  useEffect(() => {
    if (quotationEntity?.bank?.id) {
      dispatch(getBankAgreementDateLogs(quotationEntity.bank.id));
    }
  }, [quotationEntity?.bank?.id]);

  useEffect(() => {
    // jspdf html to pdf directly
    const element = document.getElementById('contentToPrint');

    const pdf = new jsPDF('p', 'pt', 'a4', true);
    const template = new jsPDF('p', 'pt', 'a4', true);
    pdf.setDisplayMode('fullpage', 'continuous', 'FullScreen');
    const width = pdf.internal.pageSize.getWidth();
    const height = pdf.internal.pageSize.getHeight();

    // sleep to wait for the certificate to fully render
    sleep(800).then(() => {
      // create template to count number of page
      template
        .html(element, {
          html2canvas: {
            scale: 0.75,
            letterRendering: true,
            backgroundColor: null,
          },
          margin: [0, 0, 20, 0],
          autoPaging: true,
        })
        .then(() => {
          html2canvas(element, { allowTaint: true, useCORS: true, logging: true }).then(canvas => {
            // remove excess blank pages
            let pageCount = template.getNumberOfPages();
            for (let i = 0; i < 7; i++) {
              template.deletePage(pageCount);
              pageCount--;
            }

            // get number of pages
            pageCount = template.getNumberOfPages();

            // put background into each page before adding content
            for (let i = 1; i <= pageCount; i++) {
              pdf.addPage();
              pdf.setPage(i);

              // change in x or y changes the position of the image
              // change in width or height stretches the image
              // pdf.addImage(logo, 'PNG', 20, 20, 80, 70);
              // pdf.addImage(watermarkLogo, 'PNG', 118, 200, 356, 300);
              // set opacity
              pdf.saveGraphicsState();
              pdf.setGState(pdf.GState({ opacity: 0.5 }));
              pdf.restoreGraphicsState();
            }

            // set content opacity
            pdf.setPage(1);
            pdf.saveGraphicsState();
            pdf.setGState(pdf.GState({ opacity: 1 }));
            // create content from html
            pdf
              .html(element, {
                html2canvas: {
                  scale: 0.75,
                  letterRendering: true,
                  backgroundColor: null,
                },
                // margin needs to be adjusted to ensure that the pages are cut correctly
                margin: [0, 0, 20, -106],
                autoPaging: true,
              })
              .then(() => {
                // pageCount = pdf.getNumberOfPages();
                // remove excess pages made by jspdf because of certain elements' positioning
                // for (let i = 0; i < 7; i++) {
                //   pdf.deletePage(pageCount);
                //   pageCount--;
                // }

                // save the pdf
                generatePDFArabic();
                // if (Storage.session.get('locale') === 'ar-ly') {
                //   pdf.save(`Transaction_Forms_Transfer_${localStorage.getItem("ecertNo")}_ARB.pdf`);
                // } else {
                //   pdf.save(`Transaction_Forms_Transfer_${localStorage.getItem("ecertNo")}_ENG.pdf`);
                // }
              });
          });
        });
    });
  }, [Storage.session.get('locale')]);

  useEffect(() => {
    forceLogoAlignment('contentToPrint');
  }, [Storage.session.get('locale')]);

  const isLocalCommodity = quotationEntity?.commodity?.isActive === true && quotationEntity?.commodity?.ownership === 'Local';

  return (
    <div
      ref={captureRef}
      id="contentToPrint"
      style={{
        position: 'relative',
        width: '795px',
        height: '1123px',
        overflow: 'hidden',
        boxShadow: '0 0 40px rgba(0, 0, 0, 0.2)',
        backgroundColor: 'transparent',
        margin: '20px auto',
      }}
    >
      <div className="head-content-margin logo-header">
        <img src={logo} className="alshmokh-logo" />
      </div>
      <br />
      <div className={Storage.session.get('locale') === 'ar-ly' ? 'main-content-margin-arabic' : 'main-content-margin'}>
        <div>
          <div className="body-content">
            <h6 className="title-text">{translate('comexApp.quotation.local-transactionForms.title.transfer')}</h6>
            <br />
            <div>
              <table className="table-1">
                <tbody>
                  <tr>
                    <td>{translate('comexApp.quotation.local-transactionForms.table1.date')}</td>
                    <td>
                      {moment(quotationEntity?.localCommodityOtcCert?.valueDate).format(
                        Storage.session.get('locale') === 'en' ? 'DD/MM/yyyy' : 'yyyy/MM/DD'
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{translate('comexApp.quotation.local-transactionForms.table1.time')}</td>
                    <td>{moment(quotationEntity?.localCommodityOtcCert?.createdDate).local().format('HH:mm:ss')}</td>
                  </tr>
                  <tr>
                    <td>{translate('comexApp.quotation.local-transactionForms.table1.from')}</td>
                    <td>
                      {quotationEntity?.bank?.name} - {quotationEntity?.branch?.name}
                    </td>
                  </tr>
                  <tr>
                    <td>{translate('comexApp.quotation.transactionForms.table1.to')}</td>
                    <td>
                      {quotationEntity?.commodity?.ownership === 'Local' && quotationEntity?.customer?.nameArabic
                        ? quotationEntity?.customer?.nameArabic
                        : quotationEntity?.customer?.name}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
            <div className="greeting-table-wrapper">
              <div className="greeting-text pb-2">
                <span className={Storage.session.get('locale') === 'ar-ly' ? 'greetings-arabic' : 'greetings'}>
                  <strong>{translate('comexApp.quotation.local-transactionForms.greetings.opening')}</strong>
                  <br />
                  {translate('comexApp.quotation.local-transactionForms.greetings.transfer', {
                    date: agreementDateFormat(quotationEntity),
                  })}
                </span>
              </div>
              <div>
                <table
                  className={Storage.session.get('locale') === 'ar-ly' ? 'table-2 table-transfer arabic' : 'table-2 table-transfer'}
                  style={Storage.session.get('locale') === 'ar-ly' ? { direction: 'rtl' } : {}}
                >
                  <tbody>
                  <tr>
                    <td>{translate('comexApp.quotation.local-transactionForms.table2.purchaseDate')}</td>
                    <td style={{
                      direction: 'ltr',
                      textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'
                    }}>{moment(quotationEntity?.localCommodityBidCert?.valueDate).format(Storage.session.get('locale') === 'en' ? 'DD/MM/yyyy' : 'yyyy/MM/DD')}</td>
                  </tr>
                  <tr>
                    <td>{translate('comexApp.quotation.local-transactionForms.table2.beneficiary')}</td>
                    <td style={{
                      direction: 'ltr',
                      textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'
                    }}>{quotationEntity?.commodity?.ownership === 'Local' && quotationEntity?.customer?.nameArabic ? quotationEntity?.customer?.nameArabic : quotationEntity?.customer?.name}</td>
                  </tr>
                  <tr>
                    <td>{translate('comexApp.quotation.local-transactionForms.table2.offerNo')}</td>
                    <td style={{
                      direction: 'ltr',
                      textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'
                    }}>{quotationEntity?.id}</td>
                  </tr>
                  <tr>
                    <td>{translate('comexApp.quotation.local-transactionForms.table2.dealNo')}</td>
                    <td style={{
                      direction: 'ltr',
                      textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'
                    }}>{quotationEntity?.localCommodityBidCert?.ecertNo}</td>
                  </tr>
                  <tr>
                    <td>{translate('comexApp.quotation.local-transactionForms.table2.commodityType')}</td>
                    <td style={{
                      direction: 'ltr',
                      textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'
                    }}>{quotationEntity?.commodity?.name}</td>
                  </tr>
                  <tr>
                    <td>{translate('comexApp.quotation.local-transactionForms.table2.totalAmount')}</td>
                    <td style={{
                      direction: 'ltr',
                      textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'
                    }}>{formatCurrency(quotationEntity?.amount?.toLocaleString(), quotationEntity?.buyCurrency)}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <br />
              <br />
              <br />
              <br />
              <br />

              <div className="footer-text">
                <strong>
                  {' '}
                  <span className={Storage.session.get('locale') === 'ar-ly' ? 'arabic' : 'english'}>
                    {translate('comexApp.quotation.local-transactionForms.faithfully')}
                  </span>
                </strong>
              </div>
            </div>

            <br />
            <br />
            <br />

            <div className="footer-text-transfer col-12">
              <div className="col-6">
                <span className={Storage.session.get('locale') === 'ar-ly' ? 'signature-text arabic' : 'signature-text'}>
                  {translate('comexApp.quotation.transactionForms.customerSignature')}
                </span>
                <div className="rectangle"></div>
              </div>
              <div className="col-6" style={{ textAlign: Storage.session.get('locale') === 'ar-ly' ? 'left' : 'right' }}>
                <span className={Storage.session.get('locale') === 'ar-ly' ? 'company-text arabic' : 'company-text english'}>
                  {translate('comexApp.quotation.local-transactionForms.alshmokhHoldingCompany')}
                </span>
                <br />
                <img src="content/images/company-stamp.jpg" alt="Company Stamp" className="company-stamp" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <img src={watermark} className={Storage.session.get('locale') === 'ar-ly' ? 'logo-watermark arabic' : 'logo-watermark'} />

      <div className="footer">
        <img src={footer} className="imageFooter" />
      </div>
    </div>
  );
};

export default LocalTransactionFormsTransfer;
